class duplicateContacts {
    constructor($state) {

        this.key = 'duplicate-contacts';
        this.title = 'Duplicates';
        this.level = 'highlight';
        this.icon = 'code-merge';
        this.order = 50;
        this.state = $state;
    }

    action({}, store) {
        return this.state.go('app.contacts.duplicates', {store: store});
    }

}

angular
    .module('festzelt-os.contacts')
    .factory('duplicateContacts', [
        '$state',
        $state => new duplicateContacts($state)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/duplicate-contacts.js